import { r as registerInstance, h } from './index-d4808923.js';
import { b as bem, a as getInitials } from './index.esm-7182addc.js';

const gravityAvatarCss = ":host{display:block}.gravity-avatar{background-color:rgba(0, 15, 30, 0.2);border-radius:9999px;box-sizing:border-box;cursor:inherit;height:100%;overflow:hidden;position:relative;width:100%}.gravity-avatar--size-xx-small{height:var(--gravity-avatar-size, 24px);width:var(--gravity-avatar-size, 24px)}.gravity-avatar--size-x-small{height:var(--gravity-avatar-size, 32px);width:var(--gravity-avatar-size, 32px)}.gravity-avatar--size-small{height:var(--gravity-avatar-size, 40px);width:var(--gravity-avatar-size, 40px)}.gravity-avatar--size-medium{height:var(--gravity-avatar-size, 48px);width:var(--gravity-avatar-size, 48px)}.gravity-avatar--size-large{height:var(--gravity-avatar-size, 56px);width:var(--gravity-avatar-size, 56px)}.gravity-avatar--size-x-large{height:var(--gravity-avatar-size, 64px);width:var(--gravity-avatar-size, 64px)}.gravity-avatar--size-xx-large{height:var(--gravity-avatar-size, 72px);width:var(--gravity-avatar-size, 72px)}.gravity-avatar--image-loaded{background:none}.gravity-avatar__container{border-radius:9999px;inset:0;overflow:hidden;position:absolute}.gravity-avatar__image{height:100%;object-fit:cover}.gravity-avatar--has-initials{background-color:rgba(0, 15, 30, 0.1)}.gravity-avatar--has-initials .gravity-avatar__container{background-color:#FFFFFF;inset:max(1px, 2.5%)}.gravity-avatar__initials{height:100%;left:0;position:absolute;top:0;width:100%}.gravity-avatar__initials-text{-moz-osx-font-smoothing:grayscale;-webkit-font-smoothing:antialiased;alignment-baseline:middle;color:rgba(0, 15, 30, 0.6);fill:currentColor;font-family:\"Bull\", Helvetica, sans-serif;font-size:30px;font-weight:500;line-height:1;text-anchor:middle}";
const GravityAvatarStyle0 = gravityAvatarCss;

const GravityAvatar = class {
    constructor(hostRef) {
        registerInstance(this, hostRef);
        this.generateClassNames = bem('gravity-avatar');
        this.name = '';
        this.picture = undefined;
        this.size = 'medium';
        this.displayInitials = undefined;
        this.imageLoaded = undefined;
    }
    validatePicture(newPicture) {
        if (this.isValidPictureUrl(newPicture)) {
            this.displayInitials = false;
            return;
        }
        this.displayInitials = true;
    }
    isValidPictureUrl(url) {
        if (typeof url !== 'string' || url.trim() === '') {
            return false;
        }
        return true;
    }
    handleImageLoadError() {
        this.displayInitials = true;
    }
    renderInitials() {
        return (h("svg", { class: this.generateClassNames('initials'), viewBox: "0 0 72 72", "aria-hidden": "true" }, h("text", { class: this.generateClassNames('initials-text'), x: "50%", y: "55%" }, getInitials(this.name))));
    }
    renderImage() {
        return (h("img", { class: this.generateClassNames('image'), alt: `Picture of ${this.name.trim()}`, src: this.picture, onError: () => this.handleImageLoadError(), onLoad: () => (this.imageLoaded = true) }));
    }
    componentWillLoad() {
        this.validatePicture(this.picture);
    }
    render() {
        return (h("div", { key: '98476a5b910ed8f05770b6719f099be025bc7ffe', class: this.generateClassNames({
                'size': this.size,
                'has-initials': this.displayInitials,
                'image-loaded': this.imageLoaded,
            }), title: this.name.trim() }, h("div", { key: 'afef10a5d7b06ef845ab85e00cc0134bade20d3a', class: this.generateClassNames('container') }, this.isValidPictureUrl(this.picture) && this.displayInitials !== true && this.renderImage(), this.displayInitials && this.renderInitials())));
    }
    static get watchers() { return {
        "picture": ["validatePicture"]
    }; }
};
GravityAvatar.style = GravityAvatarStyle0;

export { GravityAvatar as gravity_avatar };

//# sourceMappingURL=gravity-avatar.entry.js.map